import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "filter-container" }
const _hoisted_2 = { class: "filter-box" }
const _hoisted_3 = { class: "filter-box" }
const _hoisted_4 = { class: "status" }
const _hoisted_5 = { class: "el-dropdown-link table-handle-more" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_TableList = _resolveComponent("TableList")!
  const _component_FormComponent = _resolveComponent("FormComponent")!
  const _directive_waves = _resolveDirective("waves")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["list-container", { 'form-fullScreen': _ctx.isEdit }])
  }, [
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[4] || (_cache[4] = _createElementVNode("span", { class: "label" }, "发票抬头", -1)),
          _createVNode(_component_el_input, {
            modelValue: _ctx.listQuery.titleName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.listQuery.titleName) = $event)),
            style: {"width":"200px"},
            size: _ctx.t('table.btnSize'),
            class: "filter-item",
            clearable: "",
            onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
          }, null, 8, ["modelValue", "size", "onKeyup"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            type: "primary",
            size: _ctx.t('table.btnSize'),
            onClick: _ctx.handleFilter
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.search")), 1)
            ]),
            _: 1
          }, 8, ["size", "onClick"])), [
            [_directive_waves]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            type: "primary",
            size: _ctx.t('table.btnSize'),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleCommand('add')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.add")), 1)
            ]),
            _: 1
          }, 8, ["size"])), [
            [_directive_permission, { pkey: `${_ctx.permissionName}_ADD` }]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            size: _ctx.t('table.btnSize'),
            onClick: _ctx.handleReset
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.reset")), 1)
            ]),
            _: 1
          }, 8, ["size", "onClick"])), [
            [_directive_waves]
          ])
        ])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_TableList, {
        ref: "TableList",
        dataList: _ctx.list,
        total: _ctx.total,
        columnAllData: _ctx.columnAllData,
        tableName: _ctx.TableName,
        permissionName: _ctx.permissionName,
        showSelection: false,
        canRefresh: false,
        canChangeColumn: false,
        handleDefaultWidth: 240,
        maxHight: 224,
        canCommand: _ctx.canCommand,
        onCommandChange: _ctx.handleCommand
      }, {
        titleName: _withCtx((scope) => [
          _createElementVNode("span", {
            class: _normalizeClass([scope.row.changeStatus === 2 ? 'redStatusStyle' : scope.row.changeStatus === 1 ? 'yellowStatusStyle' : '', "statusStyle"])
          }, [
            (scope.row.changeStatus && scope.row.changeStatus !== 3)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _cache[5] || (_cache[5] = _createElementVNode("i", { class: "iconfont icon-tubiao-40" }, null, -1)),
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.ReviewStatusOption.find(k => k.id === scope.row.changeStatus) ? _ctx.ReviewStatusOption.find(k => k.id === scope.row.changeStatus).mark : ''), 1)
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("span", null, _toDisplayString(scope.row.titleName), 1)
          ], 2)
        ]),
        defaultValue: _withCtx((scope) => [
          _createElementVNode("span", null, _toDisplayString(scope.row.defaultValue ? '是' : '否'), 1)
        ]),
        "operation-action": _withCtx((scope) => [
          _withDirectives((_openBlock(), _createBlock(_component_el_link, {
            href: "javascript:void(0);",
            class: "mr-10",
            type: "primary",
            onClick: ($event: any) => (_ctx.handleCommand('edit', scope.row))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.edit")), 1)
            ]),
            _: 1
          }, 8, ["onClick"])), [
            [_directive_permission, { pkey: `${_ctx.permissionName}_EDIT` }]
          ]),
          _createVNode(_component_el_dropdown, null, {
            dropdown: _withCtx(() => [
              _createVNode(_component_el_dropdown_menu, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_dropdown_item, null, {
                    default: _withCtx(() => [
                      (!scope.row.defaultValue)
                        ? _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                            key: 0,
                            href: "javascript:void(0);",
                            class: "mr-10",
                            type: "primary",
                            onClick: ($event: any) => (_ctx.handleCommand('setDefaul', scope.row))
                          }, {
                            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                              _createTextVNode(" 设置默认联系人 ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["onClick"])), [
                            [_directive_permission, { pkey: `${_ctx.permissionName}_SET_DEFAULT` }]
                          ])
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_dropdown_item, null, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                        href: "javascript:void(0);",
                        class: "mr-10",
                        type: "primary",
                        onClick: ($event: any) => (_ctx.handleCommand('viewPay', scope.row))
                      }, {
                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                          _createTextVNode(" 查看付款信息 ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"])), [
                        [_directive_permission, { pkey: `${_ctx.permissionName}_VIEWP_PAY` }]
                      ])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_dropdown_item, null, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                        href: "javascript:void(0);",
                        type: "danger",
                        onClick: ($event: any) => (_ctx.handleCommand('delete', scope.row))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t("table.delete")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])), [
                        [_directive_permission, { pkey: `${_ctx.permissionName}_DELETE` }]
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_5, [
                _cache[6] || (_cache[6] = _createTextVNode(" 更多 ", -1)),
                _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_arrow_down)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["dataList", "total", "columnAllData", "tableName", "permissionName", "canCommand", "onCommandChange"])), [
        [_directive_loading, _ctx.listLoading]
      ])
    ], 512), [
      [_vShow, !_ctx.dialogFormVisible]
    ]),
    (_ctx.dialogFormVisible)
      ? (_openBlock(), _createBlock(_component_FormComponent, {
          key: 0,
          id: _ctx.activeId,
          submitParams: { customerCompanyId: _ctx.id },
          initFormData: _ctx.initFormData,
          fromFieldData: _ctx.fromFieldData,
          dialogFormVisible: _ctx.dialogFormVisible,
          handleResolveTempData: _ctx.handleResolveTempData,
          api: 'customerCompanyTicketTitle',
          "onUpdate:visibel": _cache[2] || (_cache[2] = ($event: any) => {_ctx.dialogFormVisible = false;_ctx.isEdit = false}),
          onSubmit: _cache[3] || (_cache[3] = ($event: any) => {_ctx.handleSubmit(_ctx.formData);_ctx.isEdit = false})
        }, null, 8, ["id", "submitParams", "initFormData", "fromFieldData", "dialogFormVisible", "handleResolveTempData"]))
      : _createCommentVNode("", true)
  ], 2))
}